module.exports = __webpack_public_path__ + "img/junkit-logo-blue.6fb9d817.svg";